// Exposes only the two fields the bell renders. `isLoading` is deliberately withheld: it flips on
// every poll, so selecting it would re-render the header each tick no matter how stable the list is
// (the bell has no spinner and never reads it). Shaped for a `shallowEqual` comparison, which then
// sees no change whenever the reducer preserves the `items` reference.
export const notificationsSelector = ({ notifications }) => ({
    items: notifications.items,
    unreadCount: notifications.unreadCount,
});
